import React from 'react'
import { useRouter } from 'next/router'
import { ScrollDimModal, TrainTicket } from '~/app/components'
import { OrderDetailsTrainTicket } from '~/__generated__/__types__'
import useTrainTicketData from './useTrainTicketData'

/**
 * TrainTicketModal component
 * author: soojin.oh
 */

// type definitions
type TrainTicketModalProps = OrderDetailsTrainTicket & {
  name: string
  phone: string
  birthDate: string
  isOpened: boolean
  createdAt: string
}

// styled components
const TARGET_ID = 'CHECK-TICKET'

// TrainTicketModal component
const TrainTicketModal: React.FunctionComponent<TrainTicketModalProps> = function (props) {
  const { isOpened, name, phone, birthDate, createdAt } = props
  const {
    departureAt,
    departureStationName,
    arrivalAt,
    arrivalStationName,
    passengerInformation,
    trainType,
    goodsReservationNo,
    seatInformation,
    departureDate,
    stationTrainClassifyCode,
  } = useTrainTicketData(props)

  const { back } = useRouter()

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <TrainTicket
        userName={name}
        phone={phone}
        birthDate={birthDate}
        createdAt={createdAt}
        departureAt={departureAt}
        departureStationName={departureStationName}
        arrivalAt={arrivalAt}
        arrivalStationName={arrivalStationName}
        trainType={trainType}
        passengerInformation={passengerInformation}
        goodsReservationNo={goodsReservationNo}
        seatInformation={seatInformation}
        departureDate={departureDate}
        onClickBack={back}
        stationTrainClassifyCode={stationTrainClassifyCode}
      />
    </ScrollDimModal>
  )
}

export default TrainTicketModal
